import { useDispatch, useSelector } from "react-redux"
import CardGrey from "../../../common/CardGrey"
import BodySimpleModalV2 from "../../../common/modal/BodySimpleModalV2"
import { splitFlagsBasedOnName } from "../../../../lib/systemData"

import classes from './FlagDetails.module.css'
import { useEffect, useState } from "react"
import { pullFlagsForCaseDetails } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import LoadingSpinner from "../../../common/LoadingSpinner"
import { caseActions } from "../../../../store/case"

export default function FlagsDetails({ embeddedCaseFlag = null, skipRemoteFetch = false }) {
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase)

    const [loading, setLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)

    const caseId = activeCase?.case?.id

    useEffect(() => {
        if (skipRemoteFetch || embeddedCaseFlag != null) {
            return
        }
        if (!userToken || !caseId) {
            return
        }

        let cancelled = false

        async function pullFlags() {
            setLoading(true)
            try {
                const flags = await pullFlagsForCaseDetails(userToken, caseId)

                if (cancelled) {
                    return
                }

                if (flags && flags.errorMessage) {
                    dispatch(notificationActions.setError(flags))
                } else {
                    dispatch(
                        caseActions.replaceWholeFolder({
                            folder: 'case_flag',
                            content: flags,
                        })
                    )
                }
            } finally {
                if (!cancelled) {
                    setLoading(false)
                }
            }
        }

        pullFlags()

        return () => {
            cancelled = true
        }
    }, [skipRemoteFetch, embeddedCaseFlag, userToken, caseId, dispatch])

    const flagModel = embeddedCaseFlag ?? activeCase?.case_flag
    const groups = splitFlagsBasedOnName(flagModel)

    return (
        <>
            {loading && <LoadingSpinner />}
            <div className={classes.container}>
                {!loading && groups && groups.map((item) => (
                    <div key={item.group} className={classes.item}>
                        <CardGrey>
                            <h3 className={classes.name}>{item.group}</h3>
                            <div className={classes.item_container}>
                                {item.filters &&
                                    item.filters.map((elem) => (
                                        <div key={elem.key}>
                                            <div className={classes.label}>
                                                <BodySimpleModalV2
                                                    isFlex={true}
                                                    normalEvent={true}
                                                    messages={[elem.details]}
                                                >
                                                    {elem.label}
                                                </BodySimpleModalV2>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </CardGrey>
                    </div>
                ))}
            </div>
        </>
    )
}
